export const CREDENTIALS_REQUIRED = 'Email And Password Are Required.';
export const CREDENTIALS_INVALID = 'Authentication Failed, Invalid Credentials.';
export const INVOICE_CHECK = 'Please select Invoices to continue.';
export const AUTHENTICATION_ERROR = 'Error while authenicating.';
export const CARD_NOT_SELECTED = 'Card not selected.';
export const CVV_EMPTY = 'CVV Is Required.';
export const CVV_INVALID = 'Invalid CVV number.';
export const REASON_REQUIRED = 'Reason is required.';
export const CREDIT_AMOUNT_VALIDATION_ERRORS = 'Invoices Open and Pay amount should be greter than Credit amount.';
export const OVER_PAY_NOT_ALLOWED = 'Overpayments is not allowed.';
export const PAY_AMOUNT_VALIDATION_MESSAGE = 'Total pay amount should be greater than 0.';
export const REASON_DESCRIPTION_VALIDATION_MESSAGE = 'Reason description required.';
export const GET_USER_ERROR = 'Error getting user profile from API.';
export const GET_USER_PAYER_ERROR = 'Error get user payers from API.';
export const GET_INVOICE_ERROR = 'Error getting invoices from API.';
export const GET_INVOICE_DETAIL_ERROR = 'Error getting invoice detail from API.';
export const GET_INVOICE_PDF_ERROR = 'Error getting invoices PDF from API.';
export const GET_PAYER_DETAILS_ERROR = 'Error getting payer details from API.';
export const MAKE_PAYMENT_ERROR = 'Error when making payment.';
export const GET_CONFIG_ERROR = 'Error getting configuration.';
export const GET_API_VERSION_ERROR = 'Error getting API version.';
export const RESET_PASSWORD_ERROR = 'Error while resetting the password.';
export const RESET_PASSWORD_SUCCESS = 'Password reset successfully.';
export const DUE_DATES_REQUIRED = 'Due dates required.';
export const DOCUMENT_DATES_REQUIRED = 'Document dates required.';
export const CHARACTERISTICS_VALUE_REQUIRED = 'Characteristics value required.';
